import { Component, OnInit, ViewChild } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { saveAs } from 'file-saver';
import { ConfirmationService } from 'primeng/api';
import { DataService } from 'src/app/shared/services/data.service';
import * as async from 'async';
import { ToastrService } from 'ngx-toastr';
import { v4 as uuidv4 } from 'uuid';
import { DocumentSaveModalComponent } from 'src/app/components/modals/document-save-modal/document-save-modal.component';
import { Location } from '@angular/common';
import * as _ from 'underscore';
import { IBoxService } from 'src/app/shared/services/i-box.service';
import { ParamsService } from 'src/app/shared/services/params.service';
import { loadMessages, locale } from 'devextreme/localization';
import RELocalization from 'src/assets/translations/dx-rich.fr.json';
import { IRicheditComponent } from '@devinforius/i-dx-editor';
import { DialogService } from 'primeng/dynamicdialog';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { FilesService } from 'src/app/shared/services/files.service';
import { MeService } from 'src/app/shared/services/me.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DocumentFormatApi } from 'devexpress-richedit/lib/model-api/formats/enum';
import { MailFileDto } from 'src/app/shared/interfaces';
import { DocumentTemplateDTO } from 'src/app/shared/interfaces/documents/document-template-dto.interface';
import { DocumentsService } from 'src/app/shared/services/documents.service';
import { UserInfo } from 'src/app/shared/models/iCourrier/me/user-info';
import { LibraryParagraphDto } from 'src/app/shared/interfaces/documents/library-paragraph-dto.interface';
import { environment } from 'src/environments/environment';
import { IButtonMenuItem } from '@devinforius/i-essentials/lib/models/i-button-menuitem';
import { DocumentInput } from 'src/app/shared/models';
import { DocumentFusionFieldsDTO } from 'src/app/shared/models/iCourrier/document-template';
import { catchError, forkJoin, map, of, switchMap } from 'rxjs';
import { TranslateService } from '@devinforius/i-essentials';
import { toSignal } from '@angular/core/rxjs-interop';
import { toMergeFieldsForEditor } from 'src/app/shared/utils/merge-fields-for-editor.util';

@Component({
  selector: 'app-document-editor-by-file-id',
  templateUrl: './document-editor-by-file-id.component.html',
  styleUrls: ['./document-editor-by-file-id.component.scss'],
})
export class DocumentEditorByFileIdComponent implements OnInit {
  public readonly mergeFields = toSignal(this.documentsService.getFusionsField().pipe(map(toMergeFieldsForEditor)), { initialValue: {} });


  public selectedTemplatelocation: string;
  public selectedTemplateName: string;
  public selectedTplLangue: string;
  public spellCheckLangId: number;
  public guid: string;
  public baseUrlDocumentEditor: string;
  public showDocExportBtn: boolean;
  public enableSpellCheck: boolean;
  public courrierID: number;
  public fileID: number;
  public exportBtnItems: IButtonMenuItem[] = [];
  public file: MailFileDto;
  public currentBlob: Blob;
  public types = ['.docx', '.doc', '.rtf', '.pdf', '.mail', '.printshop', '.odt', '.html', '.printshop-C5'];
  public selectedType = this.types[0];
  public lancerValidation = false;
  public userInfos: UserInfo;
  public modele: DocumentTemplateDTO;
  @ViewChild('document_editor') public documenteditorcontainer: IRicheditComponent;
  public isFormSubmit = false;

  public showFusion = false;
  public searchValue = '';
  public fusions: DocumentFusionFieldsDTO;
  public LIST_IDS: string[] = [];
  public doneList;
  public timer;

  public displayParagraphes = false;
  public searchValueBibli = '';
  public paragraphes: Record<string, LibraryParagraphDto[]>;

  public lang = localStorage.getItem('lang');

  constructor(
    private documentsService: DocumentsService,
    private spinner: NgxSpinnerService,
    private params: ParamsService,
    private _location: Location,
    private confirmService: ConfirmationService,
    private dataService: DataService,
    private filesService: FilesService,
    private toastr: ToastrService,
    private router: Router,
    private route: ActivatedRoute,
    private iBoxService: IBoxService,
    private dialogService: DialogService,
    private meService: MeService,
    private translater: TranslateService
  ) {
    if (RELocalization) {
      loadMessages({ fr: RELocalization });
      locale('fr');
    }
  }

  ngOnInit(): void {
    this.setDatas();
  }

  private setDatas(): void {
    const routeParams = this.route.snapshot.params;
    this.courrierID = +routeParams.mailId;
    this.fileID = +routeParams.fileId;
    this.loadConfig();
    this.generateRdGuid();
    forkJoin({
      userInfos: this.meService.getUserInfo().pipe(
        catchError(() => {
          this.toastr.error(this.translater.translate('error.errorOccurredWhileFetchingUserInfos'));
          return of(null);
        })
      ),
      mailFile: this.filesService.getMailsFileById(this.courrierID, this.fileID).pipe(
        catchError(() => {
          this.toastr.error(this.translater.translate('error.errorOccurredWhileFetchingFile'));
          return of(null);
        })
      ),
    })
      .pipe(
        switchMap((value) => {
          this.userInfos = value.userInfos;
          this.file = value.mailFile;

          return forkJoin({
            blobFile: this.iBoxService.downLoadFile(this.file.mailId, this.file.id).pipe(
              catchError(() => {
                this.toastr.error(this.translater.translate('error.errorOccurredWhileDownloadingFile'));
                return of(null);
              })
            ),
            modeleById: this.file.modeleId
              ? this.params.getModeleById(this.file.modeleId).pipe(
                catchError(() => {
                  this.toastr.error(this.translater.translate('error.errorOccurredWhileFetchingModele'));
                  return of(null);
                })
              )
              : of(null),
          });
        })
      )
      .subscribe((secondForkJoinValue) => {
        this.currentBlob = secondForkJoinValue.blobFile;
        this.transformDocument();
        if (this.file.modeleId && secondForkJoinValue.modeleById) {
          this.modele = secondForkJoinValue.modeleById;
        } else {
          this.modele = null;
        }
      });
  }

  public loadConfig() {
    const config = environment;
    this.baseUrlDocumentEditor = config.baseUrlDocumentEditor + 'DocumentEditor/';
    this.enableSpellCheck = config.enableSpellCheck;
    this.showDocExportBtn = config.showDocExportBtn;

    this.exportBtnItems = [
      { label: '.docx', icon: 'bi--medium_icon bi bi-filetype-doc', click: () => this.export('.docx', '.docx') },
      { label: '.doc', icon: 'bi--medium_icon bi bi-filetype-doc', click: () => this.export('.doc', '.doc') },
      { label: '.rtf', icon: 'iconRTFFileSCSS', click: () => this.export('.rtf', '.rtf') },
      { label: '.pdf', icon: 'bi--medium_icon bi bi-filetype-pdf', click: () => this.export('.pdf', '.pdf') },
      { label: '.mail', icon: '', click: () => this.export('.mail', '.html') },
      { label: '.printshop', icon: 'bi--medium_icon bi bi-filetype-pdf', click: () => this.export('.printshop', '.pdf') },
      { label: '.odt', icon: 'bi--medium_icon bi bi-filetype-pdf', click: () => this.export('.odt', '.odt') },
      { label: '.html', icon: 'bi--medium_icon bi bi-filetype-pdf', click: () => this.export('.html', '.html') },
      { label: '.printshop-C5', icon: 'bi--medium_icon bi bi-filetype-pdf', click: () => this.export('.printshop-C5', '.pdf') },
    ];
  }

  public transformDocument() {
    if (this.currentBlob) {
      this.loadBlob(this.currentBlob);
    }
  }

  public loadBlob(blob: Blob): void {
    if (this.documenteditorcontainer) {
      this.documenteditorcontainer.rich.openDocument(blob, 'document', DocumentFormatApi.Rtf, () => {
        this.spinner.hide();
      });
    }
  }

  public export(selecteType: string, saveAsType: string): void {
    this.selectedType = selecteType;
    this.spinner.show();
    let blob = null;
    this.documenteditorcontainer.rich.exportToFile((file) => {
      blob = new Blob([file], { type: 'application/rtf' });
      saveAs(blob, this.file.description.split('.')[0] + saveAsType);
      this.spinner.hide();
    }, DocumentFormatApi.Rtf);
  }

  public generateRdGuid() {
    this.guid = uuidv4();
  }

  prepareToSave() {
    if (this.file.modeleId && this.file.procedureValidationId) {
      this.confirmService.confirm({
        message: 'Relancer le document en validation (OUI) ou continuer la procédure telle quelle (NON) ?',
        accept: () => {
          this.lancerValidation = true;
          this.saveMail();
        },
        reject: () => {
          this.lancerValidation = false;
          this.saveMail();
        },
      });
    } else {
      this.saveMail();
    }
  }

  cancel() {
    this._location.back();
  }

  saveMail() {
    let description = '';
    // on check si nePasProposerRenomer si c'est le cas on prend la description du template
    if (this.file) {
      description = this.file.description ? this.file.description : 'untitled_document';
      if (description.length > 200) {
        description = description.substring(0, 199);
      }
      this.spinner.show();
      this.documenteditorcontainer.rich.exportToFile((file) => {
        const blob = new Blob([file], { type: 'application/rtf' });
        this.addDocument(blob, description);
        this.spinner.hide();
      }, DocumentFormatApi.Rtf);
    } else {
      if (this.file) {
        description = this.file.description;
      } else {
        description = 'untitled_document';
      }

      const ref = this.dialogService.open(DocumentSaveModalComponent, {
        dismissableMask: false,
        width: '60vw',
        header: 'Enregistrement du document',
        baseZIndex: 1000,
        data: {
          selectedDocumentTpl: this.file ? this.file : null,
        },
      });

      ref.onClose.subscribe({
        next: (value) => {
          if (value) {
            description = value;
            this.spinner.show();

            this.documenteditorcontainer.rich.exportToFile((file) => {
              const blob = new Blob([file], { type: 'application/rtf' });
              this.addDocument(blob, description);
              this.spinner.hide();
            }, DocumentFormatApi.Rtf);
          }
        },
      });
    }
  }

  addDocument(blob: Blob, fileName: string) {
    this.spinner.show();
    let docInput: DocumentInput;
    this.dataService.setCanLeaveEditor(true);
    this.isFormSubmit = true;

    if (this.modele && this.file) {
      docInput = new DocumentInput({
        pdfFileRequired: this.modele.nePasGenererDePdf ? false : true,
        file: blob,
        description: fileName,
        guid: this.guid,
        modeleId: this.file.modeleId,
        version: this.file.version ? this.file.version + 1 : 1,
      });
    } else {
      docInput = new DocumentInput({
        pdfFileRequired: true,
        file: blob,
        description: fileName,
        guid: this.guid,
        version: this.file.version ? this.file.version + 1 : 1,
      });
    }

    Object.keys(docInput).forEach((key) => docInput[key] == null && delete docInput[key]);

    this.filesService.addDocumentVersion(this.courrierID, this.fileID, docInput, this.lancerValidation, false, []).subscribe({
      next: () => {
        this.toastr.success('Merci', 'Votre document a été créé!');

        if (localStorage.getItem('isAnswer') === 'sortants') {
          this.router.navigateByUrl('/private/ic/courriers/' + localStorage.getItem('activeCategoryCourrier') + '/' + this.courrierID);
          localStorage.removeItem('isAnswer');
        } else {
          this.router.navigateByUrl('/private/ic/courriers/' + localStorage.getItem('activeCategoryCourrier') + '/' + this.courrierID);
        }
      },
      error: (error) => {
        console.error('Error : ', error);
        this.toastr.error("Une erreur est survenue lors de l'envoi du formulaire");
      },
    });
  }

  getFusions() {
    this.spinner.show();
    this.LIST_IDS = [];
    this.documentsService.getFusionsField().subscribe({
      next: (res) => {
        this.fusions = res;
        const keys = Object.keys(this.fusions);

        keys.forEach((key, index) => {
          this.LIST_IDS.push('cdk-drop-list-' + index);
        });
        this.spinner.hide();
      },
    });
  }

  copy(event, text) {
    if (event.detail === 1) {
      this.timer = setTimeout(() => {
        navigator.clipboard.writeText(text.key).then(
          function () {
            console.info('Async: Copying to clipboard was successful!');
          },
          function (err) {
            console.error('Async: Could not copy text: ', err);
          }
        );
        this.toastr.success('La valeur ' + text.description + ' est copié dans votre presse-papier');
      }, 500);
    }
  }

  public insert(variable) {
    const cursorPosition = this.documenteditorcontainer.rich.selection.start;
    this.documenteditorcontainer.rich.document.insertText(cursorPosition, variable);
  }

  public dropped(event: CdkDragDrop<string[]>) {
    const text = event.item && event.item.data;
    const cursorPosition = this.documenteditorcontainer.rich.selection.start;
    this.documenteditorcontainer.rich.document.insertText(cursorPosition, text);
  }

  getParagraphes() {
    this.spinner.show();
    this.LIST_IDS = [];
    this.documentsService.fetchLibraryParagraphs().subscribe({
      next: (res) => {
        this.paragraphes = _.groupBy(res, 'bibliothequeName');
        const keys = Object.keys(this.paragraphes);
        keys.forEach((key, index) => {
          this.LIST_IDS.push('cdk-drop-list-' + index);
        });
        this.spinner.hide();
      },
    });
  }

  insertParagraphes(text) {
    clearTimeout(this.timer);
    if (text.texteRtf) {
      const cursorPosition = this.documenteditorcontainer.rich.selection.start;
      this.documenteditorcontainer.rich.selection.activeSubDocument.insertRtf(cursorPosition, text.texteRtf);
    }
  }
}
